
export default {
  data() {
    return {
      notifUnread: 0,
      socket: null,
      selectedYear: new Date().getFullYear(),
      yearOptions: [
        2025,
        2026,
        2027,
        2028,
      ],
      chartGolonganData: [],
      tipe: null,
      widgetStatus: {
        total_kegiatan: 0,
        permintaan_baru: 0,
        ditolak: 0,
        siap_ambil: 0,
        selesai: 0
      },

      listJk: [],
      listBidangUsaha: [],


    }
  },

  methods: {




    async loadWidgetDashboard() {
      try {
        const raw = JSON.parse(localStorage.profile);
        const role = Number(raw.profile?.stokdarah_konut);
        const ruangan_id = raw.profile?.ruangan_id;

        let url = `statusDashboard?stokdarah_konut=${role}`;

        // HANYA role ruangan
        if (role === 3 && ruangan_id) {
          url += `&ruangan_id=${ruangan_id}`;
        }

        const res = await fetch(
          this.$store.state.url.DASHBOARD + url,
          {
            headers: {
              authorization: 'kikensbatara ' + localStorage.token
            }
          }
        );

        const json = await res.json();
        if (json.data) {
          this.widgetStatus = json.data;
        }

        this.$nextTick(() => {
          this.chartPie();
        });

      } catch (err) {
        console.error('Gagal load dashboard:', err);
      }
    },



    chartPie() {
      Highcharts.chart('chartPie', {
        chart: { type: 'pie', backgroundColor: 'transparent' },
        title: { text: 'Status Permintaan Darah' },
        tooltip: { pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>' },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: { enabled: false },
            showInLegend: true
          }
        },
        series: [{
          name: 'Jumlah',
          colorByPoint: true,
          data: [
            { name: 'Permintaan Baru', y: this.widgetStatus.permintaan_baru, color: '#1e88e5' },
            { name: 'Ditolak', y: this.widgetStatus.ditolak, color: '#ffb300' },
            { name: 'Darah Siap Ambil', y: this.widgetStatus.siap_ambil, color: '#f57c00' },
            { name: 'Selesai', y: this.widgetStatus.selesai, color: '#43a047' }
          ]
        }]
      });
    },


    renderChartGolongan() {
      const bulanLabel = [
        'Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun',
        'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'
      ];

      // siapkan 12 bulan kosong
      const template = () => Array(12).fill(0);

      const seriesMap = {
        A: template(),
        B: template(),
        AB: template(),
        O: template()
      };

      // isi dari API
      this.chartGolonganData.forEach(item => {
        const idx = item.bulan - 1;
        if (seriesMap[item.golongan_darah]) {
          seriesMap[item.golongan_darah][idx] = item.jumlah;
        }
      });

      Highcharts.chart('chartByPermintaanDarah', {
        chart: {
          type: 'line',
          backgroundColor: 'transparent'
        },
        title: {
          text: `Permintaan Darah Terpakai Tahun ${this.selectedYear}`
        },
        subtitle: {
          text: 'Berdasarkan golongan darah'
        },
        xAxis: {
          categories: bulanLabel
        },
        yAxis: {
          title: {
            text: 'Jumlah Permintaan'
          },
          allowDecimals: false
        },
        tooltip: {
          shared: true,
          valueSuffix: ' Kantong'
        },
        plotOptions: {
          line: {
            dataLabels: { enabled: true }
          }
        },
        series: [
          { name: 'Golongan A', data: seriesMap.A },
          { name: 'Golongan B', data: seriesMap.B },
          { name: 'Golongan AB', data: seriesMap.AB },
          { name: 'Golongan O', data: seriesMap.O }
        ]
      });
    },


    async loadPermintaanDarahByGolongan() {
      try {
        const res = await fetch(
          this.$store.state.url.DASHBOARD +
          `permintaanDarahByGolongan?year=${this.selectedYear}`,
          {
            headers: {
              authorization: 'kikensbatara ' + localStorage.token
            }
          }
        );

        const json = await res.json();
        this.chartGolonganData = json.data || [];

        this.$nextTick(() => {
          this.renderChartGolongan();
        });

      } catch (err) {
        console.error('Gagal load permintaan darah:', err);
      }
    },

    async loadPendonorByGender() {
      try {
        const res = await fetch(
          this.$store.state.url.DASHBOARD + 'pendonorByGender',
          {
            headers: {
              authorization: 'kikensbatara ' + localStorage.token
            }
          }
        );

        const json = await res.json();

        this.renderPendonorGenderChart(json.data || []);

      } catch (err) {
        console.error('Gagal load pendonor by gender:', err);
      }
    },

    renderPendonorGenderChart(seriesData) {
      Highcharts.chart('chartPendonorGender', {
        chart: {
          type: 'pie',
          backgroundColor: 'transparent'
        },
        title: {
          text: "Pendonor Berdasarkan Jenis Kelamin"
        },
        subtitle: {
          text: 'Perempuan & Laki-laki'
        },
        tooltip: {
          pointFormat: '<b>{point.y}</b> pendonor ({point.percentage:.1f}%)'
        },
        plotOptions: {
          pie: {
            innerSize: '60%', // 👉 DONUT
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b><br>{point.percentage:.1f} %'
            }
          }
        },
        series: [{
          name: 'Jumlah Pendonor',
          colorByPoint: true,
          data: seriesData
        }]
      });
    },

    async loadPendonorGenderTable() {
      try {
        const res = await fetch(
          this.$store.state.url.DASHBOARD + 'pendonorByGenderTable',
          {
            headers: {
              authorization: 'kikensbatara ' + localStorage.token
            }
          }
        );

        const json = await res.json();
        this.listJk = json.data || [];

      } catch (err) {
        console.error('Gagal load tabel pendonor:', err);
      }
    },

    async loadPermintaanByRuanganPie() {
      try {
        const res = await fetch(
          this.$store.state.url.DASHBOARD + 'permintaanByRuanganPie',
          {
            headers: {
              authorization: 'kikensbatara ' + localStorage.token
            }
          }
        );

        const json = await res.json();
        this.renderPermintaanRuanganPie(json.data || []);

      } catch (err) {
        console.error('Gagal load pie ruangan:', err);
      }
    },

    renderPermintaanRuanganPie(seriesData) {
      Highcharts.chart('chartPermintaanRuangan', {
        chart: {
          type: 'pie',
          backgroundColor: 'transparent'
        },
        title: {
          text: "Permintaan Darah per Ruangan"
        },
        subtitle: {
          text: null
        },
        tooltip: {
          pointFormat: '<b>{point.y}</b> permintaan ({point.percentage:.1f}%)'
        },
        plotOptions: {
          pie: {
            innerSize: '60%', // DONUT
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b><br>{point.percentage:.1f}%'
            }
          }
        },
        series: [
          {
            name: 'Jumlah Permintaan',
            colorByPoint: true,
            data: seriesData
          }
        ]
      });
    },


    async loadPermintaanByRuanganTable() {
      try {
        const res = await fetch(
          this.$store.state.url.DASHBOARD + 'permintaanByRuanganTable',
          {
            headers: {
              authorization: 'kikensbatara ' + localStorage.token
            }
          }
        );

        const json = await res.json();
        this.listBidangUsaha = json.data || [];

      } catch (err) {
        console.error('Gagal load tabel ruangan:', err);
      }
    },








  },

  mounted() {
    const get_profile = JSON.parse(localStorage.profile);

    this.tipe = Number(get_profile.profile.db_csrkonsel);

    this.mitra = {
      id: get_profile._id,
      nama: get_profile.profile.nama,
      username: get_profile.username,
      email: get_profile.email,
      telp: get_profile.profile.telp,
      alamat: get_profile.profile.alamat,
      pic: get_profile.profile.pic,
      file_name: get_profile.profile.file_name // logo perusahaan
    };

    // this.getMitra(get_profile._id);

    this.loadWidgetDashboard();
    this.loadPermintaanDarahByGolongan();
    this.loadPendonorByGender();
    this.loadPendonorGenderTable();
    this.loadPermintaanByRuanganPie();
    this.loadPermintaanByRuanganTable();
  },

  watch: {
    selectedYear() {
      this.loadPermintaanDarahByGolongan();
    }
  },


}
